import { createColumn, defaultColumns, inputTextField, relationField } from '../_defaults/columns'
import { dateFormat } from '../../plugins/filters'

export const columns = [
  createColumn({
    label: 'Membership',
    field: 'membership',
    displayValue: 'membership.company.name',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: { required: false },
      type: 'one',
      localKey: 'membershipId',
      fk: 'id',
      namespace: 'membership'
    })
  }),
  createColumn({
    label: 'Registration Date',
    field: 'registrationDate',
    type: 'date',
    description: 'Date that the membership started.',
    displayValue: row => {
      return row.registrationDate ? dateFormat(row.registrationDate, 'MMM DD YYYY') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Drop Date',
    field: 'dropDate',
    type: 'date',
    description: 'Date that the membership was dropped.',
    displayValue: row => {
      return row.dropDate ? dateFormat(row.dropDate, 'MMM DD YYYY') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Expiration Date',
    field: 'expiryDate',
    type: 'date',
    description: 'Date that the membership expires.',
    displayValue: row => {
      return row.expiryDate ? dateFormat(row.expiryDate, 'MMM DD YYYY') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Notes',
    field: 'notes',
    component: inputTextField({ type: 'textarea', req: false, max: 8192 })
  })
].concat(defaultColumns)
